import { useEffect, useState } from 'react';
import { getUserCart } from '../services/cart';
import { auth } from '../services/auth';

const useCart = (refresh) => {
  const [cart, setCart] = useState([]);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig] = useState(null);
  const user = auth().getUser();

  useEffect(() => {
    setConfig({
      headers: { Authorization: `Bearer ${auth().getToken()}` }
    });
  }, []);

  useEffect(() => {
    const fetchCart = async () => {
      if (config) {
        if (user) {
          try {
            const response = await getUserCart(user, config);
            if (response.data?.length > 0) {
              setCart(response.data[0]?.cart_Items);
            } else {
              setCart([]);
            }
          } catch (error) {
            setError(error);
          } finally {
            setIsLoading(false);
          }
        } else {
          const cartItems = JSON.parse(localStorage.getItem('cart'));
          setCart(cartItems);
          setIsLoading(false);
          setError("");
        }
      }
    }
    fetchCart();
  }, [ config, refresh]);

  return {
    mainCart: cart,
    error,
    isLoading,
  };
};

export default useCart;